import { loadStripe } from '@stripe/stripe-js';
import { config, getApiUrl } from '../config';

const stripePromise = loadStripe(config.stripe.publicKey);

export const initiateCheckout = async () => {
  const stripe = await stripePromise;

  if (!stripe) {
    throw new Error('Stripe failed to initialize');
  }

  // Get cart items and ensure they have the required properties
  const cartItems = window.localStorage.getItem('cartItems')
    ? JSON.parse(window.localStorage.getItem('cartItems') || '[]')
    : [];

  if (!cartItems.length) {
    throw new Error('Cart is empty');
  }

  // Get email from localStorage
  const email = window.localStorage.getItem('checkoutEmail');
  if (!email) {
    throw new Error('Email is required for checkout');
  }

  // Get shipping option from localStorage
  const shippingOption =
    window.localStorage.getItem('shippingOption') || 'local';

  // Validate that each item has the required properties
  interface CartItem {
    id: string;
    name: string;
    price: number;
    quantity?: number;
    imageUrl: string;
    size: string;
  }

  const validatedItems = cartItems.map((item: CartItem) => ({
    id: item.id,
    name: item.name,
    price: item.price,
    quantity: item.quantity || 1,
    imageUrl: item.imageUrl,
    size: item.size,
  }));

  const response = await fetch(`${getApiUrl('/api/create-checkout-session')}`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({
      items: validatedItems,
      email: email,
      shippingOption: shippingOption,
    }),
  });

  if (!response.ok) {
    const errorData = await response.json();
    console.error('Server error:', errorData);
    throw new Error(errorData.error || 'Failed to create checkout session');
  }

  const session = await response.json();

  if (!session.id) {
    console.error('Invalid session response:', session);
    throw new Error('Invalid checkout session response');
  }

  // Use sessionId for Stripe redirect, but display the clean order number
  const sessionId = session.sessionId || session.id;

  const result = await stripe.redirectToCheckout({
    sessionId: sessionId,
  });

  if (result.error) {
    throw new Error(result.error.message);
  }
};
